export function flatPromise() {
    const flat = {
        promise: null,
        state: 'pending',
        resolver: null,
        rejector: null,
    };
    flat.promise = new Promise((resolve, reject) => {
        flat.resolver = (data) => {
            flat.result = data;
            flat.state = 'resolved';
            resolve(data);
        };
        flat.rejector = (err) => {
            flat.error = err;
            flat.state = 'rejected';
            reject(err);
        };
    });
    return flat;
}
//# sourceMappingURL=flatPromise.js.map